import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ol_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // token expired/invalid – clear and redirect to login on next render
      localStorage.removeItem("ol_token");
      localStorage.removeItem("ol_user");
    }
    return Promise.reject(err);
  },
);

export default api;

// Helper to extract a readable error string from FastAPI responses (handles validation arrays).
export function apiErrorMessage(err, fallback = "Wystąpił błąd. Spróbuj ponownie.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export function formatPLN(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN", maximumFractionDigits: 2 }).format(n);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}


// Make a user-provided link safe for `href` — prepend https:// if scheme is missing
// so users can type "sklep.pl/produkt" without https://.
export function safeLink(raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(s) || s.startsWith("mailto:") || s.startsWith("tel:")) return s;
  return `https://${s}`;
}
